module.exports = _.take;